<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 428 470"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M299.333 171.001C427.333 171.001 427.333 256.334 427.333 256.334V299.001H299.333V256.334C299.333 256.334 299.333 220.281 274.8 188.067C271.173 183.161 266.693 178.467 262 173.987C273.093 172.281 285.253 171.001 299.333 171.001ZM0.666504 256.334C0.666504 256.334 0.666504 171.001 128.666 171.001C256.666 171.001 256.666 256.334 256.666 256.334V299.001H0.666504V256.334ZM150 341.667V384.334H278V341.667L342 405.667L278 469.667V427.001H150V469.667L85.9998 405.667L150 341.667ZM128.666 0.333984C93.2532 0.333984 64.6665 28.9207 64.6665 64.334C64.6665 99.7473 93.2532 128.334 128.666 128.334C164.08 128.334 192.666 99.7473 192.666 64.334C192.666 28.9207 164.08 0.333984 128.666 0.333984ZM299.333 0.333984C263.92 0.333984 235.333 28.9207 235.333 64.334C235.333 99.7473 263.92 128.334 299.333 128.334C334.746 128.334 363.333 99.7473 363.333 64.334C363.333 28.9207 334.746 0.333984 299.333 0.333984Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#0043CE'
    },
    width: {
      type: String,
      default: '21'
    },
    height: {
      type: String,
      default: '21'
    }
  }
}
</script>
